const state = () => ({
  selectedBox: 'employer'
});

const getters = {
  selectedBox(state) {
    return state.selectedBox;
  }
};

const mutations = {
  updateSelectedBox(state, payload) {
    state.selectedBox = payload;
  }
};

const actions = {
  updateSelectedBox({ commit }, payload) {
    commit('updateSelectedBox', payload);
  }
};

export const partnerNavigation = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
